module.exports = __webpack_public_path__ + "images/bulle.f64593e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/png/bulle.png
// module id = 21
// module chunks = 0 1